export const openExternalLink = link => {
  const linkElement = window.document.createElement('a')
  linkElement.href = link

  linkElement.target = '_blank'

  linkElement.click()
}
